<div class="disney-supplements">
  <p class="rate-detail__disney-supplements__main-label">Opcionales:</p>
  <div class="disney-supplements__meal-plan-included">
    <mb-icon-text
      class="disney-supplements__meal-plan-included__advice"
      *ngIf="!hasRoomOnlyOption"
    >
      <mb-icon icon="exclamation-circle"></mb-icon>
      <span
        >Para seleccionar esta opción deberás elegir en el próximo paso las
        entradas.</span
      >
    </mb-icon-text>
    <ng-container *ngIf="hasMealPlan">
      <p *ngIf="!hasRoomOnlyOption">Incluído en la tarifa</p>
      <mb-icon-text>
        <mb-icon icon="restaurant"></mb-icon>
        <span>Plan de comida</span>
      </mb-icon-text>
      <mb-icon-text *ngIf="isFreeMealPlan">
        <mb-icon icon="upgrade-disney"></mb-icon>
        <span>Entradas a los parques</span>
      </mb-icon-text>
    </ng-container>
    <ng-container *ngIf="hasTickets && !isFreeMealPlan">
      <p *ngIf="!hasRoomOnlyOption">No incluído en la tarifa</p>
      <mb-icon-text>
        <mb-icon icon="upgrade-disney"></mb-icon>
        <span>Entradas a los parques</span>
      </mb-icon-text>
    </ng-container>
  </div>
  <div *ngIf="!hasTickets && !hasMealPlan" class="disney-supplements__room-only">
    <p>
      En este momento <strong>no hay adicionales disponibles</strong> para esta habitación
    </p>
  </div>
</div>
